import { useNavigate, useParams } from "react-router-dom";
import { getTemplateById, updateTemplate } from "../api/templates";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import {
  addWidgetOptions,
  addZIndex,
  convertPdfArrayBuffer,
  defaultWidthHeight,
  getBase64FromUrl,
  getContainerScale,
  pdfNewWidthFun,
  radioButtonWidget,
  randomId,
  textInputWidget,
  textWidget,
} from "../utils/general";
import RenderAllPdfPage from "../components/document/RenderAllPdfPage";
import { useDrop } from "react-dnd";
import RenderPdf from "../components/document/RenderPdf";
import WidgetComponent from "../components/document/WidgetComponent";
import SignerListPlace from "../components/document/SignerListPlace";
import PlaceholderCopy from "../components/document/PlaceholderCopy";
import {
  CheckBadgeIcon,
  PencilIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DocumentTextIcon,
  EyeIcon,
  XMarkIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import DropdownWidgetOption from "../components/document/DropdownWidgetOption";
import TextInputWidgetOption from "../components/document/TextInputWidgetOption";
import DateWidgetOption from "../components/document/DateWidgetOption";
import { ArrowLeftCircleIcon, BookmarkIcon } from "@heroicons/react/16/solid";
import SendConfirmationModal from "../components/SendConfirmationModal";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
import AnimatedModal from "../components/ui/AnimatedModal";
import { Button } from "../components/ui";
import { useLoading } from "../contexts/LoadingContext";
import { v4 as uuidv4 } from "uuid";
import PagePermissionGuard from "../components/common/PagePermissionGuard";
import { getSignedUrl } from "../utils/signedUrl";
import { useAuth } from "../contexts/AuthContext";
const ConfigureDocument = ({
  templateUseData = null,
  isFromUseTemplate = false,
  sendEmail = () => {},
}) => {
  const { user, organization } = useAuth();
  const navigate = useNavigate();
  const { templateId } = useParams();
  const divRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [templateData, setTemplateData] = useState(null);
  const [pdfBase64Url, setPdfBase64Url] = useState(null);
  const [pdfArrayBuffer, setPdfArrayBuffer] = useState(null);
  const [allPages, setAllPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [signBtnPosition, setSignBtnPosition] = useState(null);
  const [isUploadPdf, setIsUploadPdf] = useState(false);
  const [containerWH, setContainerWH] = useState();
  const [pdfNewWidth, setPdfNewWidth] = useState();
  const [scale, setScale] = useState(1);
  const [zoomPercent, setZoomPercent] = useState(0);
  const [pdfOriginalWH, setPdfOriginalWH] = useState([]);
  const [pdfLoad, setPdfLoad] = useState(false);
  const [, drop] = useDrop({
    accept: "BOX",
    drop: (item, monitor) => addPositionOfSignature(item, monitor),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
  });
  const [widgetName, setWidgetName] = useState(false);
  const [dragKey, setDragKey] = useState();
  const [isDragging, setIsDragging] = useState(false);
  const [xySignature, setXYSignature] = useState({});

  const [uniqueId, setUniqueId] = useState(4896);

  const [signersdata, setSignersData] = useState([]);
  const [zIndex, setZIndex] = useState(1);
  const [owner, setOwner] = useState({});
  const [signerPos, setSignerPos] = useState([]);
  const [isCheckbox, setIsCheckbox] = useState(false);
  const [isRadio, setIsRadio] = useState(false);
  const [isTextInput, setIsTextInput] = useState(false);
  const [isDateModal, setIsDateModal] = useState(false);

  const [fontSize, setFontSize] = useState();
  const [fontColor, setFontColor] = useState();

  const [currWidgetsDetails, setCurrWidgetsDetails] = useState([]);
  const [widgetType, setWidgetType] = useState("");
  const [signKey, setSignKey] = useState();

  const [selectWidgetId, setSelectWidgetId] = useState("");
  const [IsReceipent, setIsReceipent] = useState(true);
  const [isResize, setIsResize] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isNameModal, setIsNameModal] = useState(false);
  const [isSelectListId, setIsSelectId] = useState();
  const [tempSignerId, setTempSignerId] = useState("");
  const [unSignedWidgetId, setUnSignedWidgetId] = useState("");
  const [isPageCopy, setIsPageCopy] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewPageNumber, setPreviewPageNumber] = useState(1);

  const [roleName, setRoleName] = useState("");
  const [blockColor, setBlockColor] = useState("");
  const [isCC, setIsCC] = useState([]);

  const [showSendModal, setShowSendModal] = useState(false);
  const [isAskForAttachments, setIsAskForAttachments] = useState(false);
  const [documentRequiredMessage, setDocumentRequiredMessage] = useState("");
  const [isOTPVerificationEnabled, setIsOTPVerificationEnabled] =
    useState(false);
  const [clickToPlaceMode, setClickToPlaceMode] = useState(false);
  const [selectedWidgetType, setSelectedWidgetType] = useState(null);
  const { showLoader, hideLoader } = useLoading();
  const [showPagesSidebar, setShowPagesSidebar] = useState(false);
  const [showClearAllModal, setShowClearAllModal] = useState(false);
  const [showClearRecipientModal, setShowClearRecipientModal] = useState(false);
  const [recipientToClear, setRecipientToClear] = useState(null);
  const [selectedUserForClear, setSelectedUserForClear] = useState(null);
  const [showSaveSuccessModal, setShowSaveSuccessModal] = useState(false);

  const setLocalFormState = async (template) => {
    const url = template.documentId.filePath;
    if (url) {
      try {
        const signedUrl = await getSignedUrl(url);
        const arrayBuffer = await convertPdfArrayBuffer(signedUrl);
        const base64Pdf = await getBase64FromUrl(signedUrl);
        if (arrayBuffer === "Error") {
          toast.error("Something went wrong");
        } else {
          setPdfBase64Url(base64Pdf);
          setPdfArrayBuffer(arrayBuffer);
        }
      } catch (error) {
        console.error("Error fetching signed URL:", error);
        toast.error("Failed to load document");
      }
    }
    const RECIPIENT_COLORS_HEX = {
      "bg-blue-500": "#3b82f6",
      "bg-green-500": "#22c55e",
      "bg-yellow-500": "#eab308",
      "bg-purple-500": "#a855f7",
      "bg-pink-500": "#ec4899",
      "bg-indigo-500": "#6366f1",
      "bg-red-500": "#ef4444",
      "bg-teal-500": "#14b8a6",
    };

    const templateRecipients = [...template.recipients];
    if (!isFromUseTemplate) {
      setIsCC(templateRecipients.filter((item) => item.isCC));
    }
    const filteredRecipients = templateRecipients.filter((item) => !item.isCC);

    const allSigners = filteredRecipients.map((item) => ({
      ...item,
      placeHolder: item?.placeHolder ? item?.placeHolder : [],
      color: RECIPIENT_COLORS_HEX[item.color],
      blockColor: RECIPIENT_COLORS_HEX[item.color],
      Role: item._id,
      signerObjId: item._id,
      Id: item._id || uuidv4(),
    }));
    setSignersData(allSigners);
    setSignerPos(allSigners);

    setIsSelectId(0);
    setUniqueId(allSigners[0]?.Id);
    setRoleName(allSigners[0]?.role);
    setBlockColor(allSigners[0]?.blockColor);
    setDocumentRequiredMessage(template.documentRequiredMessage);
    setIsAskForAttachments(template.documentRequired);

    // Check if any recipient has OTP enabled to set the master toggle
    const hasAnyOTPEnabled = templateRecipients.some(
      (recipient) => !recipient.isCC && recipient.requireOtpVerification,
    );
    setIsOTPVerificationEnabled(
      template.otpVerificationEnabled || hasAnyOTPEnabled || false,
    );
  };
  useEffect(() => {
    if (templateId && !isFromUseTemplate) {
      // console.log("first if", templateId);
      const fetchTemplate = async () => {
        try {
          setIsLoading(true);
          const response = await getTemplateById(templateId);
          const template = response.data;

          setTemplateData(template);

          await setLocalFormState(template);
        } catch (error) {
          console.error("Error fetching template:", error);
          toast.error(error.message || "Failed to fetch template");
          // navigate('/dashboard/templates');
        } finally {
          setIsLoading(false);
        }
      };

      fetchTemplate();
    }
    if (isFromUseTemplate) {
      // console.log("second if", templateUseData);
      const templateDataCallback = async () => {
        setTemplateData(templateUseData);
        await setLocalFormState(templateUseData);
      };
      templateDataCallback();
    }
  }, [isFromUseTemplate, templateId, templateUseData]);

  useEffect(() => {
    const updateSize = () => {
      if (divRef.current) {
        const pdfWidth = pdfNewWidthFun(divRef);
        setPdfNewWidth(pdfWidth);
        setContainerWH({
          width: divRef.current.offsetWidth,
          height: divRef.current.offsetHeight,
        });
        setScale(1);
        setZoomPercent(0);
      }
    };

    // Use setTimeout to wait for the transition to complete
    const timer = setTimeout(updateSize, 100); // match the transition duration

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divRef.current]);

  // Handle Escape key to cancel click-to-place mode
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && clickToPlaceMode) {
        cancelClickToPlaceMode();
      }
    };

    if (clickToPlaceMode) {
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [clickToPlaceMode]);

  const addPositionOfSignature = (item, monitor) => {
    if (item && item.text) {
      setWidgetName(item.text);
    }
    getSignerPos(item, monitor);
  };

  const getSignerPos = (item, monitor) => {
    try {
      // console.log(uniqueId);
      if (uniqueId) {
        const signer = signersdata.find((x) => x.Id === uniqueId);

        if (signer) {
          const posZIndex = zIndex + 1;
          setZIndex(posZIndex);
          const containerScale = getContainerScale(
            pdfOriginalWH,
            pageNumber,
            containerWH,
          );
          const key = randomId();
          const dragTypeValue = item?.text ? item.text : monitor.type;
          const widgetWidth =
            defaultWidthHeight(dragTypeValue).width * containerScale;
          const widgetHeight =
            defaultWidthHeight(dragTypeValue).height * containerScale;
          let dropData = [],
            currentPagePosition,
            filterSignerPos;
          let placeHolder;
          if (item === "onclick") {
            // `getBoundingClientRect()` is used to get accurate measurement height of the div
            const divHeight = divRef.current.getBoundingClientRect().height;
            const dropObj = {
              //onclick put placeholder center on pdf
              xPosition: widgetWidth / 4 + containerWH.width / 2,
              yPosition: widgetHeight + divHeight / 2,
              isStamp:
                (dragTypeValue === "stamp" || dragTypeValue === "image") &&
                true,
              key: key,
              scale: containerScale,
              zIndex: posZIndex,
              type: dragTypeValue,
              options: addWidgetOptions(dragTypeValue, owner),
              Width: widgetWidth / (containerScale * scale),
              Height: widgetHeight / (containerScale * scale),
            };
            dropData.push(dropObj);
            placeHolder = { pageNumber: pageNumber, pos: dropData };
          } else {
            const offset = monitor.getClientOffset();
            //adding and updating drop position in array when user drop signature button in div
            const containerRect = document
              .getElementById("container")
              .getBoundingClientRect();
            const x = offset.x - containerRect.left;
            const y = offset.y - containerRect.top;
            const getXPosition = signBtnPosition[0]
              ? x - signBtnPosition[0].xPos
              : x;
            const getYPosition = signBtnPosition[0]
              ? y - signBtnPosition[0].yPos
              : y;
            const dropObj = {
              xPosition: getXPosition / (containerScale * scale),
              yPosition: getYPosition / (containerScale * scale),
              isStamp:
                (dragTypeValue === "stamp" || dragTypeValue === "image") &&
                true,
              key: key,
              scale: containerScale,
              // isMobile: isMobile,
              zIndex: posZIndex,
              type: item.text,
              options: addWidgetOptions(dragTypeValue, owner),
              Width: widgetWidth / (containerScale * scale),
              Height: widgetHeight / (containerScale * scale),
            };

            dropData.push(dropObj);
            placeHolder = { pageNumber: pageNumber, pos: dropData };
          }
          if (dragTypeValue === textWidget) {
            filterSignerPos = signerPos.find((data) => data.Role === "prefill");
          } else {
            filterSignerPos = signerPos.find((data) => data.Id === uniqueId);
          }

          const getPlaceHolder = filterSignerPos?.placeHolder;
          if (getPlaceHolder) {
            //checking exist placeholder on same page
            currentPagePosition = getPlaceHolder.find(
              (data) => data.pageNumber === pageNumber,
            );
          }

          //checking current page has already some placeholders then update that placeholder and add upcoming placehoder position
          if (getPlaceHolder && currentPagePosition) {
            const updatePlace = getPlaceHolder.filter(
              (data) => data.pageNumber !== pageNumber,
            );
            const getPos = currentPagePosition?.pos;
            const newSignPos = getPos.concat(dropData);
            let xyPos = { pageNumber: pageNumber, pos: newSignPos };
            updatePlace.push(xyPos);
            let updatesignerPos;
            if (dragTypeValue === textWidget) {
              updatesignerPos = signerPos.map((x) =>
                x.Role === "prefill" ? { ...x, placeHolder: updatePlace } : x,
              );
            } else {
              updatesignerPos = signerPos.map((x) =>
                x.Id === uniqueId ? { ...x, placeHolder: updatePlace } : x,
              );
            }
            setSignerPos(updatesignerPos);
            //// console.log(signerPos, "signerPos");
          } else {
            //if condition when widget type is prefill label text widget
            if (dragTypeValue === textWidget) {
              //check text widgets data (prefill) already exist then and want to add text widget on new page
              //create new page entry with old data and update placeholder
              if (filterSignerPos) {
                const addPrefillData =
                  filterSignerPos && filterSignerPos?.placeHolder;
                addPrefillData.push(placeHolder);
                const updatePrefillPos = signerPos.map((x) =>
                  x.Role === "prefill"
                    ? { ...x, placeHolder: addPrefillData }
                    : x,
                );
                setSignerPos(updatePrefillPos);
                //// console.log(signerPos, "signerPos");
              } //else condition if user do not have any text widget data
              else {
                const prefillTextWidget = {
                  signerPtr: {},
                  signerObjId: "",
                  blockColor: "#f58f8c",
                  placeHolder: [placeHolder],
                  Role: "prefill",
                  Id: key,
                };
                setSignerPos((prev) => [...prev, prefillTextWidget]);
                //// console.log(signerPos, "signerPos");
              }
            } else {
              //else condition to add placeholder widgets on multiple page first time
              const updatesignerPos = signerPos.map((x) =>
                x.Id === uniqueId && x?.placeHolder
                  ? { ...x, placeHolder: [...x.placeHolder, placeHolder] }
                  : x.Id === uniqueId
                    ? { ...x, placeHolder: [placeHolder] }
                    : x,
              );
              setSignerPos(updatesignerPos);
            }
          }

          // if (dragTypeValue === "dropdown") {
          //   setShowDropdown(true);
          // } else
          if (dragTypeValue === "checkbox") {
            setIsCheckbox(true);
          } else if (dragTypeValue === radioButtonWidget) {
            setIsRadio(true);
          } else if (dragTypeValue === textInputWidget) {
            setIsTextInput(true);
          } else if (dragTypeValue === "date") {
            setIsDateModal(true);
          } else if (
            [textWidget, "name", "company", "job title", "email"].includes(
              dragTypeValue,
            )
          ) {
            setFontSize(12);
            setFontColor("black");
          }
          setCurrWidgetsDetails({});
          setWidgetType(dragTypeValue);
          setSignKey(key);
          setSelectWidgetId(key);
        } else {
          setIsReceipent(false);
        }
      } else {
        // setIsAddRole(true);
      }
    } catch (error) {
      console.error("Error fetching template:", error);
    }
  };

  const pageDetails = async (pdf) => {
    let pdfWHObj = [];
    const totalPages = pdf?.numPages;
    setAllPages(totalPages);
    for (let index = 0; index < totalPages; index++) {
      const getPage = await pdf.getPage(index + 1);
      const scale = 1;
      const { width, height } = getPage.getViewport({ scale });
      pdfWHObj.push({ pageNumber: index + 1, width, height });
    }
    setPdfOriginalWH(pdfWHObj);
    setPdfLoad(true);
  };

  const handleTabDrag = (key) => {
    setDragKey(key);
    setIsDragging(true);
  };
  //function for change page
  function changePage(offset) {
    setSignBtnPosition([]);
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  //function for capture position on hover or touch widgets
  const handleDivClick = (e) => {
    const isTouchEvent = e.type.startsWith("touch");
    const divRect = e.currentTarget.getBoundingClientRect();
    let mouseX, mouseY;
    if (isTouchEvent) {
      const touch = e.touches[0]; // Get the first touch point
      mouseX = touch.clientX - divRect.left;
      mouseY = touch.clientY - divRect.top;
      setSignBtnPosition([{ xPos: mouseX, yPos: mouseY }]);
    } else {
      mouseX = e.clientX - divRect.left;
      mouseY = e.clientY - divRect.top;
      const xyPosition = { xPos: mouseX, yPos: mouseY };
      setXYSignature(xyPosition);
    }
  };

  //function for capture position of x and y on hover signature button last position
  const handleMouseLeave = () => {
    setSignBtnPosition([xySignature]);
  };
  const handleDeleteSign = (key, Id) => {
    const updateData = [];
    const filterSignerPos = signerPos.filter((data) => data.Id === Id);

    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;

      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber,
      );

      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos.filter(
          (data) => data.key !== key,
        );

        if (getXYdata.length > 0) {
          updateData.push(getXYdata);
          const newUpdatePos = getPlaceHolder.map((obj) => {
            if (obj.pageNumber === pageNumber) {
              return { ...obj, pos: updateData[0] };
            }
            return obj;
          });

          const newUpdateSigner = signerPos.map((obj) => {
            if (obj.Id === Id) {
              return { ...obj, placeHolder: newUpdatePos };
            }
            return obj;
          });

          setSignerPos(newUpdateSigner);
        } else {
          const getRemainPage = filterSignerPos[0].placeHolder.filter(
            (data) => data.pageNumber !== pageNumber,
          );
          //condition to check placeholder length is greater than 1 do not need to remove whole placeholder
          //array only resove particular widgets
          if (getRemainPage && getRemainPage.length > 0) {
            const newUpdatePos = filterSignerPos.map((obj) => {
              if (obj.Id === Id) {
                return { ...obj, placeHolder: getRemainPage };
              }
              return obj;
            });
            let signerupdate = [];
            signerupdate = signerPos.filter((data) => data.Id !== Id);
            signerupdate.push(newUpdatePos[0]);

            setSignerPos(signerupdate);
          } else {
            const updatedData = signerPos.map((item) => {
              if (item.Id === Id) {
                // Create a copy of the item object and delete the placeHolder field
                const updatedItem = { ...item };
                delete updatedItem.placeHolder;
                return updatedItem;
              }
              return item;
            });
            setSignerPos(updatedData);
          }
        }
      }
    }
  };

  // Function to clear widgets for selected user
  const handleClearAllWidgets = () => {
    if (!selectedUserForClear) {
      toast.error("Please select a user");
      return;
    }

    const updatedSignerPos = signerPos.map((item) => {
      if (item.Id === selectedUserForClear) {
        const updatedItem = { ...item };
        delete updatedItem.placeHolder;
        return updatedItem;
      }
      return item;
    });
    setSignerPos(updatedSignerPos);
    const recipient = signersdata.find((r) => r.Id === selectedUserForClear);
    setShowClearAllModal(false);
    setSelectedUserForClear(null);
    toast.success(
      `Widgets cleared for ${recipient?.name || recipient?.role || "selected user"}`,
    );
  };

  // Function to clear widgets for a specific recipient
  const handleClearRecipientWidgets = (recipientId) => {
    const updatedSignerPos = signerPos.map((item) => {
      if (item.Id === recipientId) {
        const updatedItem = { ...item };
        delete updatedItem.placeHolder;
        return updatedItem;
      }
      return item;
    });
    setSignerPos(updatedSignerPos);
    const recipient = signersdata.find((r) => r.Id === recipientId);
    setShowClearRecipientModal(false);
    setRecipientToClear(null);
    toast.success(
      `Widgets cleared for ${recipient?.role || recipient?.name || "recipient"}`,
    );
  };

  // Function to open clear recipient modal
  const openClearRecipientModal = (recipientId) => {
    setRecipientToClear(recipientId);
    setShowClearRecipientModal(true);
  };
  //function for set and update x and y postion after drag and drop signature tab
  const handleStop = (event, dragElement, signerId, key) => {
    setFontColor();
    setFontSize();
    if (!isResize && isDragging) {
      const dataNewPlace = addZIndex(signerPos, key, setZIndex);
      let updateSignPos = [...signerPos];
      updateSignPos.splice(0, updateSignPos.length, ...dataNewPlace);
      const signId = signerId; //? signerId : signerObjId;
      const keyValue = key ? key : dragKey;
      const containerScale = getContainerScale(
        pdfOriginalWH,
        pageNumber,
        containerWH,
      );
      if (keyValue >= 0) {
        let filterSignerPos;
        if (signId) {
          filterSignerPos = updateSignPos.filter((data) => data.Id === signId);
        } else {
          filterSignerPos = updateSignPos.filter(
            (data) => data.Role === "prefill",
          );
        }
        //// console.log("filterSignerPos", filterSignerPos);
        if (filterSignerPos.length > 0) {
          const getPlaceHolder = filterSignerPos[0].placeHolder;
          const getPageNumer = getPlaceHolder.filter(
            (data) => data.pageNumber === pageNumber,
          );
          if (getPageNumer.length > 0) {
            const getXYdata = getPageNumer[0].pos;
            const getPosData = getXYdata;
            const addSignPos = getPosData.map((url) => {
              if (url.key === keyValue) {
                return {
                  ...url,
                  xPosition: dragElement.x / (containerScale * scale),
                  yPosition: dragElement.y / (containerScale * scale),
                };
              }
              return url;
            });

            const newUpdateSignPos = getPlaceHolder.map((obj) => {
              if (obj.pageNumber === pageNumber) {
                return { ...obj, pos: addSignPos };
              }
              return obj;
            });
            const newUpdateSigner = updateSignPos.map((obj) => {
              if (signId) {
                if (obj.Id === signId) {
                  return { ...obj, placeHolder: newUpdateSignPos };
                }
              } else {
                if (obj.Role === "prefill") {
                  return { ...obj, placeHolder: newUpdateSignPos };
                }
              }
              return obj;
            });
            setSignerPos(newUpdateSigner);
          }
        }
      }
    }
    setTimeout(() => setIsDragging(false), 200);
  };

  const handleRoleChange = (event, roleId) => {
    // Update the role when the content changes
    const updatedRoles = signersdata.map((role) =>
      role.Id === roleId ? { ...role, Role: event.target.value } : role,
    );
    setSignersData(updatedRoles);
    const updatedPlaceholder = signerPos.map((role) =>
      role.Id === roleId ? { ...role, Role: event.target.value } : role,
    );
    setSignerPos(updatedPlaceholder);
  };
  //  `handleOnBlur` function is call when user click outside input box
  const handleOnBlur = (updateRole, roleId) => {
    // Update the role when the content changes
    if (!updateRole) {
      const updatedRoles = signersdata.map((role) =>
        role.Id === roleId ? { ...role, Role: roleName } : role,
      );
      setSignersData(updatedRoles);
      const updatedPlaceholder = signerPos?.map((role) =>
        role.Id === roleId ? { ...role, Role: roleName } : role,
      );
      setSignerPos(updatedPlaceholder);
    }
  };

  const validatePlaceholders = (payload) => {
    // Validate phone numbers for recipients with OTP verification enabled
    const recipientsRequiringOTP = payload.recipients.filter(
      (recipient) => !recipient.isCC && recipient.requireOtpVerification,
    );

    if (recipientsRequiringOTP.length > 0) {
      const recipientsWithoutPhone = recipientsRequiringOTP.filter(
        (recipient) => !recipient.phone || recipient.phone.trim() === "",
      );
      if (recipientsWithoutPhone.length > 0) {
        const recipientNames = recipientsWithoutPhone
          .map((r) => r.name || r.role)
          .join(", ");
        toast.error(
          `Phone number is required for recipients with OTP verification enabled: ${recipientNames}`,
        );
        return false;
      }
    }

    // console.log("payload", payload);
    let hasMissingOneField = false;
    let hasMissingOneFieldErr = "";
    let hasMissingSignature = false;

    // Create a copy of recipients to avoid mutating the original payload
    const recipients = [...payload.recipients];

    for (const recipient of recipients) {
      if (recipient.isCC) {
        continue;
      }

      // console.log("signerPos", signerPos);
      const placeHolder = signerPos.find((pos) => pos.Id === recipient._id);

      if (placeHolder) {
        recipient.placeHolder = placeHolder?.placeHolder || [];
      } else {
        // console.log("else", recipient);
        recipient.placeHolder = [];
      }

      // console.log("recipient.placeHolder", recipient, recipient.placeHolder);

      // Check if recipient has any placeholders
      if (!recipient.placeHolder.length) {
        hasMissingOneField = true;
        hasMissingOneFieldErr = `For ${recipient.role} At least one widget is required`;
        continue;
      }

      // Check for signature widget in each page
      let hasSignatureOnAnyPage = false;
      for (const widget of recipient.placeHolder) {
        const signatureWidget = widget.pos.find(
          (pos) => pos.type === "signature",
        );
        if (signatureWidget) {
          hasSignatureOnAnyPage = true;
          break;
        }
      }

      if (!hasSignatureOnAnyPage) {
        hasMissingSignature = true;
        break;
      }
    }

    // if (hasMissingSignature) {
    //   toast.error("At least one signature is required for all recipients");
    //   return false;
    // }

    if (hasMissingOneField) {
      toast.error(hasMissingOneFieldErr);
      return false;
    }

    return true;
  };
  const handleSaveTemplate = async () => {
    const payload = { ...templateData };
    const isValidate = validatePlaceholders(payload);
    if (!isValidate) {
      return;
    }
    try {
      showLoader();
      await updateTemplate(templateId, {
        ...payload,
        documentConfigured: true,
        recipients: JSON.stringify(payload.recipients),
        documentRequiredMessage: documentRequiredMessage,
        documentRequired: isAskForAttachments,
      });
      toast.success("Template updated successfully");
      setShowSaveSuccessModal(true);
    } catch (error) {
      console.error("Error updating template:", error);
      toast.error(error.message || "Failed to update template");
    } finally {
      hideLoader();
    }
  };
  const prepareSendEmail = (expiryDateTime) => {
    const payload = { ...templateData };
    const isValidate = validatePlaceholders(payload);
    if (!isValidate) {
      return;
    }
    // let hasMissingOneField = false;
    // let hasMissingOneFieldErr = "";
    // let hasMissingSignature = false;
    // payload.recipients.map((recipient) => {
    //   if (recipient.isCC) {
    //     return recipient;
    //   }
    //   const placeHolder = signerPos.find((pos) => pos.Id === recipient._id);
    //   if (placeHolder) {
    //     recipient.placeHolder = placeHolder.placeHolder || [];
    //   }

    //   // check for signnatur widget
    //   for (const widget of recipient.placeHolder) {
    //     const signatureWidget = widget.pos.find(
    //       (pos) => pos.type === "signature"
    //     );
    //     if (!signatureWidget) {
    //       hasMissingSignature = true;
    //       break;
    //     }
    //   }

    //   if (!recipient.placeHolder.length) {
    //     hasMissingOneField = true;
    //     hasMissingOneFieldErr = `For ${recipient.role} At least one widget is required`;
    //   }

    //   return recipient;
    // });

    // if (hasMissingSignature) {
    //   toast.error("At least one signature is required for all recipients");
    //   return;
    // }

    // if (hasMissingOneField) {
    //   toast.error(hasMissingOneFieldErr);
    //   return;
    // }

    if (expiryDateTime) {
      payload.expiryDateTime = expiryDateTime;
    }

    sendEmail({
      ...payload,
      recipients: payload.recipients.map((recipient) => {
        delete recipient._id;
        return recipient;
      }),
      documentRequiredMessage: documentRequiredMessage,
      documentRequired: isAskForAttachments,
    });
  };

  const handleNameModal = () => {
    setIsNameModal(false);
    setCurrWidgetsDetails({});
    setShowDropdown(false);
    setIsRadio(false);
    setIsCheckbox(false);
    setIsTextInput(false);
    setIsDateModal(false);
    //condition for text widget type after set all values for text widget
    //change setUniqueId which is set in tempsignerId
    //because textwidget do not have signer user so for selected signers we have to do
    if (currWidgetsDetails.type === textWidget) {
      setUniqueId(tempSignerId);
      setTempSignerId("");
    }
  };

  // Function to handle widget click and open configuration modal
  const handleWidgetClickConfig = (widgetData) => {
    // Set the current widget details
    setCurrWidgetsDetails(widgetData);
    setSignKey(widgetData.key);
    setWidgetType(widgetData.type);

    // Set the appropriate signer and page context
    if (widgetData.data && widgetData.data.Id) {
      setUniqueId(widgetData.data.Id);
      const checkIndex = signerPos.findIndex(
        (data) => data.Id === widgetData.data.Id,
      );
      setIsSelectId(checkIndex || 0);
    }

    // Open the appropriate configuration modal based on widget type
    if (widgetData.type === radioButtonWidget) {
      setIsRadio(true);
    } else if (widgetData.type === "dropdown") {
      setShowDropdown(true);
    }
    //  else if (widgetData.type === "checkbox") {
    //   setIsCheckbox(true);
    // }
    else if (widgetData.type === textInputWidget) {
      setIsTextInput(true);
    } else if (widgetData.type === "date") {
      setIsDateModal(true);
    } else {
      setIsNameModal(true);
    }
  };

  const handleSaveDateWidgetOptions = (dateInputType) => {
    const filterSignerPos = signerPos.filter((data) => data.Id === uniqueId);
    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;
      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber,
      );
      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos;
        const addSignPos = getXYdata.map((position) => {
          if (position.key === signKey) {
            return {
              ...position,
              options: {
                ...position.options,
                dateInputType,
              },
            };
          }
          return position;
        });
        const newUpdateSignPos = getPlaceHolder.map((obj) =>
          obj.pageNumber === pageNumber ? { ...obj, pos: addSignPos } : obj,
        );
        const newUpdateSigner = signerPos.map((obj) =>
          obj.Id === uniqueId ? { ...obj, placeHolder: newUpdateSignPos } : obj,
        );
        setSignerPos(newUpdateSigner);
      }
    }
    handleNameModal();
  };

  const handleSaveWidgetsOptions = (
    dropdownName,
    dropdownOptions,
    minCount,
    maxCount,
    isReadOnly,
    addOption,
    deleteOption,
    status,
    defaultValue,
    isHideLabel,
    maxLength,
    minLength,
  ) => {
    const filterSignerPos = signerPos.filter((data) => data.Id === uniqueId);
    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;

      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber,
      );

      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos;

        const getPosData = getXYdata;
        const addSignPos = getPosData.map((position) => {
          if (position.key === signKey) {
            if (widgetType === radioButtonWidget) {
              if (addOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height + 15
                    : defaultWidthHeight(widgetType).height + 15,
                };
              } else if (deleteOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height - 15
                    : defaultWidthHeight(widgetType).height - 15,
                };
              } else {
                return {
                  ...position,
                  options: {
                    ...position.options,
                    name: dropdownName,
                    values: dropdownOptions,
                    status: status,
                    defaultValue: defaultValue,
                    isReadOnly: isReadOnly || false,
                    isHideLabel: isHideLabel || false,
                    fontSize:
                      fontSize || currWidgetsDetails?.options?.fontSize || 12,
                    fontColor:
                      fontColor ||
                      currWidgetsDetails?.options?.fontColor ||
                      "black",
                  },
                };
              }
            } else if (widgetType === "checkbox") {
              if (addOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height + 15
                    : defaultWidthHeight(widgetType).height + 15,
                };
              } else if (deleteOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height - 15
                    : defaultWidthHeight(widgetType).height - 15,
                };
              } else {
                return {
                  ...position,
                  options: {
                    ...position.options,
                    name: dropdownName,
                    values: dropdownOptions,
                    validation: {
                      minRequiredCount: minCount,
                      maxRequiredCount: maxCount,
                    },
                    isReadOnly: isReadOnly || false,
                    defaultValue: defaultValue,
                    isHideLabel: isHideLabel || false,
                    fontSize:
                      fontSize || currWidgetsDetails?.options?.fontSize || 12,
                    fontColor:
                      fontColor ||
                      currWidgetsDetails?.options?.fontColor ||
                      "black",
                  },
                };
              }
            } else if (widgetType === textInputWidget) {
              return {
                ...position,
                options: {
                  ...position.options,
                  name: dropdownName,
                  status: status,
                  defaultValue: defaultValue,
                  isReadOnly: isReadOnly || false,
                  fontSize:
                    fontSize || currWidgetsDetails?.options?.fontSize || 12,
                  fontColor:
                    fontColor ||
                    currWidgetsDetails?.options?.fontColor ||
                    "black",
                  maxLength:
                    maxLength || currWidgetsDetails?.options?.maxLength || "",
                  minLength:
                    minLength || currWidgetsDetails?.options?.minLength || "",
                },
              };
            } else {
              return {
                ...position,
                options: {
                  ...position.options,
                  name: dropdownName,
                  status: status,
                  values: dropdownOptions,
                  defaultValue: defaultValue,
                  fontSize:
                    fontSize || currWidgetsDetails?.options?.fontSize || 12,
                  fontColor:
                    fontColor ||
                    currWidgetsDetails?.options?.fontColor ||
                    "black",
                  ...(isReadOnly ? { isReadOnly: isReadOnly || false } : {}),
                },
              };
            }
          }
          return position;
        });

        const newUpdateSignPos = getPlaceHolder.map((obj) => {
          if (obj.pageNumber === pageNumber) {
            return { ...obj, pos: addSignPos };
          }
          return obj;
        });
        const newUpdateSigner = signerPos.map((obj) => {
          if (obj.Id === uniqueId) {
            return { ...obj, placeHolder: newUpdateSignPos };
          }
          return obj;
        });

        setSignerPos(newUpdateSigner);
        if (!addOption && !deleteOption) {
          handleNameModal();
        }
      }
    }
    setFontSize();
    setFontColor();
  };
  const handleAttachmentChange = (e, signerId) => {
    const updatedSigners = templateData.recipients.map((signer) =>
      signer._id === signerId
        ? { ...signer, requiredAttachment: e.target.checked }
        : signer,
    );
    setTemplateData({ ...templateData, recipients: updatedSigners });
  };

  const handleOTPChange = (e, signerId) => {
    const currentPlanName = organization?.planId;
    const hasOTPAccess =
      organization?.planMeta?.OTP_VERIFICATION ||
      currentPlanName === "BUSINESS" ||
      currentPlanName === "BUSINESS_PRO";

    if (!hasOTPAccess) {
      toast.error(
        "OTP verification is available in Business and higher plans. Please upgrade your plan to enable this feature.",
      );
      return;
    }

    // Find the signer to check if they have a phone number
    const signer = templateData.recipients.find((s) => s._id === signerId);

    // If trying to enable OTP, check if phone number exists
    if (e.target.checked) {
      if (!signer?.phone || signer.phone.trim() === "") {
        toast.error(
          `Phone number is required for ${signer?.name || "this recipient"} to enable OTP verification.`,
        );
        return; // Don't update the state, keep toggle OFF
      }
    }

    const updatedSigners = templateData.recipients.map((signer) =>
      signer._id === signerId
        ? { ...signer, requireOtpVerification: e.target.checked }
        : signer,
    );
    setTemplateData({ ...templateData, recipients: updatedSigners });
  };

  // Function to handle click-to-place mode
  const handleWidgetClick = (widgetType) => {
    setClickToPlaceMode(true);
    setSelectedWidgetType(widgetType);
    // Add visual feedback to the PDF container
    if (divRef.current) {
      divRef.current.style.cursor = "crosshair";
      divRef.current.classList.add("click-to-place-mode");
    }
  };

  // Function to handle PDF container click in click-to-place mode
  const handlePdfContainerClick = (e) => {
    if (clickToPlaceMode && selectedWidgetType) {
      // Check if click is within the PDF container bounds
      const rect = divRef.current.getBoundingClientRect();
      const isWithinBounds =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;

      if (isWithinBounds) {
        // Create a mock item object for the existing addPositionOfSignature function
        const mockItem = {
          text: selectedWidgetType,
          type: selectedWidgetType,
        };

        // Create a mock monitor object
        const mockMonitor = {
          getClientOffset: () => ({ x: e.clientX, y: e.clientY }),
          type: selectedWidgetType,
        };

        // Call the existing function to place the widget
        addPositionOfSignature(mockItem, mockMonitor);
      }

      // Reset click-to-place mode
      setClickToPlaceMode(false);
      setSelectedWidgetType(null);
      if (divRef.current) {
        divRef.current.style.cursor = "default";
        divRef.current.classList.remove("click-to-place-mode");
      }
    }
  };

  // Function to cancel click-to-place mode
  const cancelClickToPlaceMode = () => {
    setClickToPlaceMode(false);
    setSelectedWidgetType(null);
    if (divRef.current) {
      divRef.current.style.cursor = "default";
      divRef.current.classList.remove("click-to-place-mode");
    }
  };

  // Function to generate sample signature/initials image as data URL
  const generateInitialsImage = (initials = "JD") => {
    const canvas = document.createElement("canvas");
    canvas.width = 200;
    canvas.height = 100;
    const ctx = canvas.getContext("2d");

    // Draw background
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw border
    ctx.strokeStyle = "#007bff";
    ctx.lineWidth = 2;
    ctx.strokeRect(1, 1, canvas.width - 2, canvas.height - 2);

    // Draw initials/signature text using a cursive font for more realistic look
    ctx.fillStyle = "#000000";
    // Use one of the imported cursive fonts from index.css
    ctx.font =
      "48px 'Dancing Script', 'Fasthand', 'Cedarville Cursive', cursive";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(initials, canvas.width / 2, canvas.height / 2);

    return canvas.toDataURL("image/png");
  };

  // Function to generate sample data for preview
  const generatePreviewData = (signerPosData) => {
    // Get current date in MM/DD/YYYY format
    const now = new Date();
    const currentDate = now.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    const sampleData = {
      text: "Sample Text",
      name: "John Doe",
      email: "john.doe@example.com",
      company: "Acme Corporation",
      jobTitle: "Software Engineer",
      date: currentDate,
      initials: generateInitialsImage("JD"),
      signature: generateInitialsImage("Signature"),
    };

    return signerPosData.map((signer) => {
      if (!signer.placeHolder) return signer;

      const updatedPlaceHolder = signer.placeHolder.map((placeholder) => {
        if (!placeholder.pos) return placeholder;

        const updatedPos = placeholder.pos.map((pos) => {
          const updatedOptions = { ...pos.options };
          const widgetName = pos.options?.name; // Store original name

          // Generate sample data based on widget type
          switch (pos.type) {
            case textInputWidget:
              updatedOptions.defaultValue = sampleData.text;
              updatedOptions.response = sampleData.text;
              break;
            case "name":
              updatedOptions.defaultValue = sampleData.name;
              updatedOptions.response = sampleData.name;
              break;
            case "email":
              updatedOptions.defaultValue = sampleData.email;
              updatedOptions.response = sampleData.email;
              break;
            case "company":
              updatedOptions.defaultValue = sampleData.company;
              updatedOptions.response = sampleData.company;
              break;
            case "job title":
              updatedOptions.defaultValue = sampleData.jobTitle;
              updatedOptions.response = sampleData.jobTitle;
              break;
            case "date":
              updatedOptions.defaultValue = sampleData.date;
              updatedOptions.response = sampleData.date;
              break;
            case "checkbox":
              // Check first option by default
              if (pos.options?.values && pos.options.values.length > 0) {
                updatedOptions.defaultValue = [0];
                updatedOptions.response = [0];
              }
              break;
            case radioButtonWidget:
              // Select first option by default
              if (pos.options?.values && pos.options.values.length > 0) {
                updatedOptions.defaultValue = pos.options.values[0];
                updatedOptions.response = pos.options.values[0];
              }
              break;
            case "initials":
              // Generate sample initials image
              return {
                ...pos,
                SignUrl: sampleData.initials,
                options: updatedOptions,
              };
            case "signature":
              // Generate sample signature image
              return {
                ...pos,
                SignUrl: sampleData.signature,
                options: updatedOptions,
              };
            default:
              break;
          }

          // For other widget types, return with updated options
          return {
            ...pos,
            options: updatedOptions,
          };
        });

        return {
          ...placeholder,
          pos: updatedPos,
        };
      });

      return {
        ...signer,
        placeHolder: updatedPlaceHolder,
      };
    });
  };

  // Helper: get signer markers for a given page (used in preview)
  const getPreviewPageSigners = (pageNum) => {
    if (!signerPos || !Array.isArray(signerPos)) return [];

    const pageSignersMap = {};

    signerPos.forEach((signer) => {
      if (signer?.placeHolder && signer.placeHolder.length > 0) {
        signer.placeHolder.forEach((data) => {
          if (data?.pageNumber && data?.pos && data.pos.length > 0) {
            const pNum = data.pageNumber;
            if (!pageSignersMap[pNum]) {
              pageSignersMap[pNum] = [];
            }
            pageSignersMap[pNum].push({
              signerId: signer.Id,
              signerName: signer.name,
              color: signer?.blockColor || signer?.color || "red",
            });
          }
        });
      }
    });

    return pageSignersMap[pageNum] || [];
  };

  return (
    <PagePermissionGuard
      module="templates"
      action="update"
      pageName="Configure Document"
    >
      <div className="flex flex-1 min-h-0 flex-col h-full overflow-hidden w-full">
        <div className="flex flex-1 min-h-0 flex-col md:flex-row overflow-hidden bg-gray-100">
          <aside className="flex w-full md:w-[300px] lg:w-[320px] shrink-0 flex-col bg-white border-b md:border-b-0 md:border-r border-gray-200 max-h-[40vh] md:max-h-none md:h-full min-h-0 overflow-hidden">
            <div className="shrink-0 border-b border-gray-200 p-3 overflow-x-auto">
              <SignerListPlace
                signerPos={signerPos}
                setSignerPos={setSignerPos}
                signersdata={signersdata}
                isSelectListId={isSelectListId}
                setRoleName={setRoleName}
                setIsSelectId={setIsSelectId}
                handleAddSigner={() => {}}
                setUniqueId={setUniqueId}
                handleDeleteUser={() => {}}
                handleRoleChange={handleRoleChange}
                handleOnBlur={handleOnBlur}
                title={"Roles"}
                sendInOrder={templateData?.isSequential}
                setSignersData={setSignersData}
                blockColor={blockColor}
                setBlockColor={setBlockColor}
                uniqueId={uniqueId}
                onClearRecipientWidgets={openClearRecipientModal}
              />
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto hide-scrollbar">
              <div className="pb-8">
                <PlaceholderCopy
                  isPageCopy={isPageCopy}
                  setIsPageCopy={setIsPageCopy}
                  xyPosition={signerPos}
                  setXyPosition={setSignerPos}
                  allPages={allPages}
                  pageNumber={pageNumber}
                  signKey={signKey}
                  Id={uniqueId}
                  widgetType={widgetType}
                  setUniqueId={setUniqueId}
                  tempSignerId={tempSignerId}
                  setTempSignerId={setTempSignerId}
                />
                <div data-tut="addWidgets">
                  <WidgetComponent
                    handleDivClick={handleDivClick}
                    handleMouseLeave={handleMouseLeave}
                    isSignYourself={false}
                    addPositionOfSignature={addPositionOfSignature}
                    title={"Roles"}
                    initial={true}
                    isTemplateFlow={true}
                    handleWidgetClick={handleWidgetClick}
                    clickToPlaceMode={clickToPlaceMode}
                    selectedWidgetType={selectedWidgetType}
                    cancelClickToPlaceMode={cancelClickToPlaceMode}
                    onClearAllWidgets={() => setShowClearAllModal(true)}
                  />
                  <DropdownWidgetOption
                    type="checkbox"
                    title={"Checkbox"}
                    showDropdown={isCheckbox}
                    setShowDropdown={setIsCheckbox}
                    handleSaveWidgetsOptions={handleSaveWidgetsOptions}
                    currWidgetsDetails={currWidgetsDetails}
                    setCurrWidgetsDetails={setCurrWidgetsDetails}
                    handleClose={handleNameModal}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    fontColor={fontColor}
                    setFontColor={setFontColor}
                    isShowAdvanceFeature={true}
                  />

                  <DropdownWidgetOption
                    type={radioButtonWidget}
                    title={"Radio Button"}
                    showDropdown={isRadio}
                    setShowDropdown={setIsRadio}
                    handleSaveWidgetsOptions={handleSaveWidgetsOptions}
                    currWidgetsDetails={currWidgetsDetails}
                    setCurrWidgetsDetails={setCurrWidgetsDetails}
                    handleClose={handleNameModal}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    fontColor={fontColor}
                    setFontColor={setFontColor}
                    isShowAdvanceFeature={true}
                  />

                  <TextInputWidgetOption
                    type={textInputWidget}
                    title={"Text Input"}
                    showDropdown={isTextInput}
                    setShowDropdown={setIsTextInput}
                    handleSaveWidgetsOptions={handleSaveWidgetsOptions}
                    currWidgetsDetails={currWidgetsDetails}
                    setCurrWidgetsDetails={setCurrWidgetsDetails}
                    handleClose={handleNameModal}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    fontColor={fontColor}
                    setFontColor={setFontColor}
                  />

                  <DateWidgetOption
                    isOpen={isDateModal}
                    onClose={handleNameModal}
                    onSave={handleSaveDateWidgetOptions}
                    initialDateInputType={
                      currWidgetsDetails?.options?.dateInputType || "free"
                    }
                  />
                </div>
                {/* <hr /> */}
                <div className="">
                  {/* Enhanced Header */}
                  <div className="mx-4 py-3">
                    <div className="flex items-center gap-3">
                      <div>
                        <div className="flex gap-2 items-center">
                          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center shrink-0">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                              />
                            </svg>
                          </div>
                          <h3 className="text-sm font-semibold text-gray-900">
                            Document Attachments
                            <span>
                              <p className="text-[10px] text-gray-500 font-normal">
                                Configure attachment requirements for recipients
                              </p>
                            </span>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Main Toggle */}
                  <div className="mx-4 mt-1">
                    <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border border-gray-200">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 justify-between">
                          <h4 className="font-medium text-gray-900 text-[13px]">
                            Enable Attachment Collection
                          </h4>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={isAskForAttachments}
                              onChange={(e) => {
                                if (
                                  organization?.planMeta?.ATTACHMENT_REQUESTS
                                ) {
                                  setIsAskForAttachments(e.target.checked);
                                } else {
                                  toast.error(
                                    "You are not allowed to enable attachment collection, please upgrade your plan.",
                                  );
                                  e.target.checked = false;
                                }
                              }}
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                          </label>
                        </div>
                        <p className="text-[10px] text-gray-500 mt-1">
                          Allow recipients to upload required documents
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Attachment Configuration */}
                  {isAskForAttachments && (
                    <div className="mx-4 mt-4 space-y-4">
                      {/* Message Configuration */}
                      <div className="bg-white border border-gray-200 rounded-lg p-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Attachment Request Message
                        </label>
                        <textarea
                          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                          rows="3"
                          placeholder="Enter a message explaining what documents are required from recipients..."
                          value={documentRequiredMessage}
                          onChange={(e) =>
                            setDocumentRequiredMessage(e.target.value)
                          }
                        />
                        <p className="text-xs text-gray-500 mt-2">
                          This message will be shown to recipients when they
                          need to upload documents.
                        </p>
                      </div>

                      {/* Recipient Selection */}
                      {templateData?.recipients?.length > 0 && (
                        <div className="bg-white border border-gray-200 rounded-lg p-4">
                          <h4 className="text-sm font-medium text-gray-700 mb-3">
                            Select Recipients
                          </h4>
                          <div className="space-y-3">
                            {templateData?.recipients?.map(
                              (signer) =>
                                !signer?.isCC && (
                                  <div
                                    key={signer._id}
                                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200"
                                  >
                                    <div className="flex items-center gap-3">
                                      <div
                                        // style={{
                                        //   background: signer?.blockColor
                                        //     ? signer?.blockColor
                                        //     : "transparent",
                                        // }}
                                        className={`w-8 h-8 ${
                                          signer?.color
                                            ? signer?.color
                                            : "bg-blue-500"
                                        } rounded-full flex items-center justify-center text-white font-semibold text-sm`}
                                      >
                                        {signer.name.charAt(0).toUpperCase()}
                                      </div>
                                      <div>
                                        <p className="font-medium text-gray-900">
                                          {signer.name}
                                        </p>
                                        <p className="text-[10px] text-gray-500">
                                          {signer.role}
                                        </p>
                                      </div>
                                    </div>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="sr-only peer"
                                        onChange={(e) =>
                                          handleAttachmentChange(e, signer._id)
                                        }
                                        checked={signer.requiredAttachment}
                                      />
                                      <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-600"></div>
                                    </label>
                                  </div>
                                ),
                            )}
                          </div>
                          <p className="text-xs text-gray-500 mt-3">
                            Toggle switches to select which recipients need to
                            provide attachments.
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  {/* OTP Verification Section */}
                  <div className="mx-4 mt-6 border-t border-gray-200 pt-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-6 w-6 text-blue-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                          />
                        </svg>
                      </div>
                      <h3 className="text-sm font-semibold text-gray-900">
                        OTP Verification
                        <span>
                          <p className="text-[10px] text-gray-500 font-normal">
                            Configure OTP verification for recipients
                          </p>
                        </span>
                      </h3>
                    </div>

                    {/* Main Toggle */}
                    <div className=" mt-1">
                      <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 justify-between">
                            <h4 className="font-medium text-gray-900 text-[13px]">
                              Enable OTP Verification
                            </h4>
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={isOTPVerificationEnabled}
                                onChange={(e) => {
                                  const currentPlanName = organization?.planId;
                                  const hasOTPAccess =
                                    organization?.planMeta?.OTP_VERIFICATION ||
                                    currentPlanName === "BUSINESS" ||
                                    currentPlanName === "BUSINESS_PRO";

                                  if (!hasOTPAccess) {
                                    toast.error(
                                      "OTP verification is available in Business and higher plans. Please upgrade your plan to enable this feature.",
                                    );
                                    return;
                                  }

                                  // If trying to enable OTP, check if any recipients have phone numbers
                                  if (e.target.checked) {
                                    const recipientsWithPhone =
                                      templateData?.recipients?.filter(
                                        (signer) =>
                                          !signer.isCC &&
                                          signer.phone &&
                                          signer.phone.trim() !== "",
                                      ) || [];

                                    if (recipientsWithPhone.length === 0) {
                                      toast.error(
                                        "At least one recipient must have a phone number to enable OTP verification.",
                                      );
                                      return; // Don't update the state, keep toggle OFF
                                    }
                                  }

                                  setIsOTPVerificationEnabled(e.target.checked);
                                  // If disabling, clear all per-recipient OTP flags
                                  if (!e.target.checked) {
                                    const updatedSigners =
                                      templateData?.recipients?.map(
                                        (signer) => ({
                                          ...signer,
                                          requireOtpVerification: false,
                                        }),
                                      ) || [];
                                    setTemplateData({
                                      ...templateData,
                                      recipients: updatedSigners,
                                    });
                                  }
                                }}
                              />
                              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                            </label>
                          </div>
                          <p className="text-[10px] text-gray-500 mt-1">
                            Require recipients to verify their identity with an
                            OTP sent to their phone before signing
                          </p>
                          {isOTPVerificationEnabled && (
                            <p className="text-[10px] text-orange-600 mt-2 font-medium">
                              ⚠️ Phone numbers are required for recipients with
                              OTP verification enabled
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* OTP Configuration */}
                    {isOTPVerificationEnabled && (
                      <div className="mx-4 mt-4 space-y-4">
                        {/* Recipient Selection */}
                        {templateData?.recipients?.length > 0 && (
                          <div className="bg-white border border-gray-200 rounded-lg p-4">
                            <h4 className="text-[13px] font-medium text-gray-700 mb-3">
                              Select Recipients
                            </h4>
                            <div className="space-y-3">
                              {templateData?.recipients?.map(
                                (signer) =>
                                  !signer?.isCC && (
                                    <div
                                      key={signer._id}
                                      className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200"
                                    >
                                      <div className="flex items-center gap-3">
                                        <div
                                          className={`w-8 h-8 ${
                                            signer?.color
                                              ? signer?.color
                                              : "bg-blue-500"
                                          } rounded-full flex items-center justify-center text-white font-semibold text-sm`}
                                        >
                                          {signer.name.charAt(0).toUpperCase()}
                                        </div>
                                        <div>
                                          <p className="font-medium text-gray-900">
                                            {signer.name}
                                          </p>
                                          <p className="text-[10px] text-gray-500">
                                            {signer.role}
                                          </p>
                                          {signer.requireOtpVerification &&
                                            (!signer.phone ||
                                              signer.phone.trim() === "") && (
                                              <p className="text-[10px] text-red-500 mt-1">
                                                Phone number required
                                              </p>
                                            )}
                                        </div>
                                      </div>
                                      <label
                                        className={`relative inline-flex items-center ${
                                          !signer.phone ||
                                          signer.phone.trim() === ""
                                            ? "cursor-not-allowed opacity-50"
                                            : "cursor-pointer"
                                        }`}
                                      >
                                        <input
                                          type="checkbox"
                                          className="sr-only peer"
                                          onChange={(e) =>
                                            handleOTPChange(e, signer._id)
                                          }
                                          checked={
                                            signer.requireOtpVerification ||
                                            false
                                          }
                                          disabled={
                                            !signer.phone ||
                                            signer.phone.trim() === ""
                                          }
                                        />
                                        <div
                                          className={`w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600 ${
                                            !signer.phone ||
                                            signer.phone.trim() === ""
                                              ? "opacity-50 cursor-not-allowed"
                                              : ""
                                          }`}
                                        ></div>
                                      </label>
                                    </div>
                                  ),
                              )}
                            </div>
                            <p className="text-[10px] text-gray-500 mt-3">
                              Toggle switches to select which recipients need
                              OTP verification.
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </aside>

          <div className="flex-1 flex flex-col min-w-0 min-h-0 relative bg-gray-100">
            <div className="flex-1 min-h-0 flex flex-col min-w-0 bg-gray-100">
              <div
                ref={divRef}
                data-tut="reactourThird"
                className={`flex-1 min-h-0 md:w-[85%] mx-auto overflow-y-auto overflow-x-auto ${
                  clickToPlaceMode ? "click-to-place-mode" : ""
                }`}
                onClick={handlePdfContainerClick}
              >
                {containerWH && (
                  <RenderPdf
                    pageNumber={pageNumber}
                    pdfNewWidth={pdfNewWidth}
                    pdfDetails={templateData}
                    signerPos={signerPos}
                    successEmail={false}
                    numPages={1}
                    pageDetails={pageDetails}
                    placeholder={true}
                    drop={drop}
                    handleDeleteSign={handleDeleteSign}
                    handleTabDrag={handleTabDrag}
                    handleStop={handleStop}
                    setPdfLoad={setPdfLoad}
                    pdfLoad={pdfLoad}
                    setSignerPos={setSignerPos}
                    containerWH={containerWH}
                    setIsResize={setIsResize}
                    setZIndex={setZIndex}
                    handleLinkUser={() => {}}
                    setUniqueId={setUniqueId}
                    signersdata={signersdata}
                    setIsPageCopy={setIsPageCopy}
                    setSignKey={setSignKey}
                    isDragging={isDragging}
                    setShowDropdown={setShowDropdown}
                    setCurrWidgetsDetails={setCurrWidgetsDetails}
                    setWidgetType={setWidgetType}
                    setIsRadio={setIsRadio}
                    setSelectWidgetId={setSelectWidgetId}
                    selectWidgetId={selectWidgetId}
                    setIsCheckbox={setIsCheckbox}
                    setIsTextInput={setIsTextInput}
                    handleNameModal={setIsNameModal}
                    pdfOriginalWH={pdfOriginalWH}
                    setScale={setScale}
                    scale={scale}
                    setIsSelectId={setIsSelectId}
                    pdfBase64Url={pdfBase64Url}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                    fontColor={fontColor}
                    setFontColor={setFontColor}
                    isResize={isResize}
                    divRef={divRef}
                    setTempSignerId={setTempSignerId}
                    uniqueId={uniqueId}
                    unSignedWidgetId={unSignedWidgetId}
                    handleWidgetClick={handleWidgetClickConfig}
                  />
                )}
              </div>

              <div className="shrink-0 flex flex-wrap items-center justify-between px-4 gap-2 border-t border-gray-200 py-2 bg-white">
                {/* <button
                  type="button"
                  onClick={() => setShowPagesSidebar(true)}
                  className="md:hidden w-10 h-10 rounded-full border border-gray-200 bg-white flex items-center justify-center shrink-0"
                  title="Pages"
                >
                  <DocumentTextIcon className="w-5 h-5" />
                </button>
                <div className="relative group">
                  <Button
                    variant="outline"
                    size="default"
                    onClick={() => setShowPreview(true)}
                    leftIcon={EyeIcon}
                    className="rounded-full px-4"
                  />
                  <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 text-xs font-medium text-white bg-gray-900 rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50">
                    <span className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-900" />
                    Preview document with placed widgets
                  </span>
                </div> */}
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline"
                    size="default"
                    onClick={() => setShowClearAllModal(true)}
                    title="Clear widgets for a specific user"
                    leftIcon={XMarkIcon}
                    className="text-red-600 border-red-600"
                  >
                    Clear Widgets
                  </Button>

                  {!isFromUseTemplate && (
                    <Button
                      variant="outline"
                      size="default"
                      onClick={() =>
                        navigate(`/dashboard/templates/update/${templateId}`)
                      }
                      leftIcon={PencilIcon}
                      className="rounded-full px-4"
                    >
                      Edit Template
                    </Button>
                  )}
                  {isFromUseTemplate && (
                    <Button
                      variant="outline"
                      size="default"
                      onClick={() => navigate(-1)}
                      leftIcon={ArrowLeftCircleIcon}
                    >
                      Back to Details
                    </Button>
                  )}
                </div>
                {!isFromUseTemplate && (
                  <Button
                    variant="primary"
                    size="default"
                    onClick={handleSaveTemplate}
                    leftIcon={CheckBadgeIcon}
                  >
                    Save Template
                  </Button>
                )}
                {isFromUseTemplate && (
                  <Button
                    variant="primary"
                    size="default"
                    onClick={() => setShowSendModal(true)}
                    leftIcon={CheckBadgeIcon}
                  >
                    Send Document
                  </Button>
                )}
              </div>
            </div>
          </div>

          <div className="hidden md:flex fixed right-4 top-1/2 -translate-y-1/2 z-30 w-14 rounded-xl border border-gray-200 bg-white shadow-sm flex-col items-center py-3 gap-3">
            <button
              type="button"
              onClick={() => setShowPreview(true)}
              className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center"
              title="View all pages"
            >
              <EyeIcon className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={() => setShowPagesSidebar(true)}
              className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center"
              title="View all pages"
            >
              <DocumentTextIcon className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={() => changePage(-1)}
              disabled={pageNumber <= 1}
              className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
              title="Previous page"
            >
              <ChevronUpIcon className="w-5 h-5" />
            </button>
            <span className="text-[11px] font-medium text-black">
              {pageNumber}/{allPages || 1}
            </span>
            <button
              type="button"
              onClick={() => changePage(1)}
              disabled={pageNumber >= allPages}
              className="w-10 h-10 rounded-lg border border-gray-200 text-black hover:bg-gray-50 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed"
              title="Next page"
            >
              <ChevronDownIcon className="w-5 h-5" />
            </button>
          </div>

          {showPagesSidebar && (
            <div className="fixed inset-0 z-50">
              <div
                className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                onClick={() => setShowPagesSidebar(false)}
              />
              <div className="absolute right-0 top-0 h-full w-80 max-w-[85vw] bg-white shadow-2xl border-l border-gray-200 animate-sidebar-in">
                <div className="flex justify-between items-center px-4 py-4 border-b border-gray-200 bg-gray-50/50">
                  <h3 className="font-semibold text-gray-900">Pages</h3>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => setShowPagesSidebar(false)}
                    className="!p-2 rounded-lg"
                  >
                    <XMarkIcon className="w-5 h-5" />
                  </Button>
                </div>
                <div className="overflow-y-auto h-[calc(100%-60px)]">
                  <RenderAllPdfPage
                    allPages={allPages}
                    setAllPages={setAllPages}
                    signerPos={signerPos}
                    setPageNumber={setPageNumber}
                    setSignBtnPosition={setSignBtnPosition}
                    pageNumber={pageNumber}
                    pdfBase64Url={pdfBase64Url}
                    signedUrl={templateData?.documentId?.path || ""}
                    setPdfArrayBuffer={setPdfArrayBuffer}
                    setPdfBase64Url={setPdfBase64Url}
                    setIsUploadPdf={setIsUploadPdf}
                    pdfArrayBuffer={pdfArrayBuffer}
                    isMergePdfBtn={false}
                    changePage={changePage}
                    from="mobile"
                    shopPageArrow={false}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <SendConfirmationModal
          isOpen={showSendModal}
          onClose={() => setShowSendModal(false)}
          onConfirm={(expiryDateTime) => prepareSendEmail(expiryDateTime)}
        />

        {/* Template Saved Success Modal */}
        <AnimatedModal
          isOpen={showSaveSuccessModal}
          onClose={() => setShowSaveSuccessModal(false)}
          closeOnBackdrop
          zIndex="z-[9999]"
          contentClassName="bg-white overflow-hidden shadow-xl border border-gray-100 max-w-lg w-full"
        >
          <div className="px-4 pt-5 pb-4 sm:p-6">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                <CheckCircleIcon className="h-6 w-6 text-green-600" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg font-medium text-gray-900">
                  Template saved successfully
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  Do you want to use this template now?
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse sm:gap-3">
            <Button
              type="button"
              variant="primary"
              size="default"
              onClick={() => {
                setShowSaveSuccessModal(false);
                navigate(`/dashboard/templates/use-template/${templateId}`);
              }}
            >
              Yes, use template
            </Button>
            <Button
              type="button"
              variant="outline"
              size="default"
              onClick={() => {
                setShowSaveSuccessModal(false);
                navigate(`/dashboard/templates`);
              }}
            >
              Not now
            </Button>
          </div>
        </AnimatedModal>

        {/* Clear Widgets Confirmation Modal */}
        <AnimatedModal
          isOpen={showClearAllModal}
          onClose={() => {
            setShowClearAllModal(false);
            setSelectedUserForClear(null);
          }}
          closeOnBackdrop
          zIndex="z-[9999]"
          contentClassName="bg-white overflow-hidden shadow-xl border border-gray-100 max-w-lg w-full"
        >
          <div className="px-4 pt-5 pb-4 sm:p-6">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                <h3 className="text-lg font-medium text-gray-900">
                  Clear Widgets
                </h3>
                <div className="mt-4">
                  <p className="text-sm text-gray-500 mb-4">
                    Confirming this will clear the widgets for the specific user
                    you select below.
                  </p>
                  <div>
                    <label
                      htmlFor="user-select"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Select User
                    </label>
                    <div className="relative">
                      <select
                        id="user-select"
                        value={selectedUserForClear || ""}
                        onChange={(e) =>
                          setSelectedUserForClear(e.target.value)
                        }
                        className="block w-full pl-3 pr-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary sm:text-sm appearance-none bg-white"
                      >
                        <option value="">-- Select a user --</option>
                        {signersdata.map((signer) => (
                          <option key={signer.Id} value={signer.Id}>
                            {signer.name || signer.role || `User ${signer.Id}`}
                          </option>
                        ))}
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse sm:gap-3">
            <Button
              type="button"
              variant="danger"
              size="default"
              onClick={handleClearAllWidgets}
              disabled={!selectedUserForClear}
            >
              Clear Widgets
            </Button>
            <Button
              type="button"
              variant="outline"
              size="default"
              onClick={() => {
                setShowClearAllModal(false);
                setSelectedUserForClear(null);
              }}
            >
              Cancel
            </Button>
          </div>
        </AnimatedModal>

        {/* Clear Recipient Widgets Confirmation Modal */}
        <DeleteConfirmationModal
          isOpen={showClearRecipientModal}
          onClose={() => {
            setShowClearRecipientModal(false);
            setRecipientToClear(null);
          }}
          onConfirm={() => {
            if (recipientToClear) {
              handleClearRecipientWidgets(recipientToClear);
            }
          }}
          title="Clear Widgets for Recipient"
          message={
            recipientToClear
              ? `Are you sure you want to clear all widgets for ${
                  signersdata.find((r) => r.Id === recipientToClear)?.role ||
                  signersdata.find((r) => r.Id === recipientToClear)?.name ||
                  "this recipient"
                }? This action cannot be undone.`
              : "Are you sure you want to clear all widgets for this recipient? This action cannot be undone."
          }
        />

        {/* Document Preview Modal */}
        {showPreview && (
          <div
            className="fixed inset-0 overflow-hidden bg-black/90 backdrop-blur-sm"
            style={{ zIndex: 9999 }}
          >
            <div className="flex flex-col h-full">
              {/* Preview Header */}
              <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
                <div className="flex items-center gap-4">
                  <h2 className="text-xl font-semibold text-gray-900">
                    Document Preview
                  </h2>
                  <div className="flex items-center gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() =>
                        setPreviewPageNumber((prev) =>
                          prev > 1 ? prev - 1 : prev,
                        )
                      }
                      disabled={previewPageNumber === 1}
                      className="!p-2"
                    >
                      <ChevronLeftIcon className="w-5 h-5" />
                    </Button>
                    <span className="text-sm font-medium text-gray-700 px-2">
                      Page {previewPageNumber} of {allPages || 1}
                    </span>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() =>
                        setPreviewPageNumber((prev) =>
                          prev < (allPages || 1) ? prev + 1 : prev,
                        )
                      }
                      disabled={previewPageNumber === (allPages || 1)}
                      className="!p-2"
                    >
                      <ChevronRightIcon className="w-5 h-5" />
                    </Button>
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    setShowPreview(false);
                    setPreviewPageNumber(1);
                  }}
                  className="!p-2 text-gray-500 hover:text-gray-700"
                >
                  <XMarkIcon className="w-6 h-6" />
                </Button>
              </div>

              {/* Preview Content */}
              <div className="flex-1 overflow-x-auto overflow-y-auto bg-gray-100">
                <div className="min-h-full flex items-start justify-center p-4 sm:p-8">
                  <div className="bg-white shadow-2xl rounded-lg p-2 sm:p-4 w-auto min-w-0 max-w-none mx-auto relative">
                    {containerWH && pdfBase64Url && (
                      <>
                        {/* Page bookmark markers (similar to main view) */}
                        <div className="absolute z-20 top-[1px] left-[-10px] flex flex-col gap-1">
                          {getPreviewPageSigners(previewPageNumber).map(
                            (signer, signerIndex) => (
                              <div
                                key={`${signer.signerId}-${signerIndex}`}
                                className="flex items-center gap-1 bg-white rounded-full px-1 py-1 shadow-sm border"
                                style={{ borderColor: signer.color }}
                              >
                                <BookmarkIcon
                                  className="w-3 h-3"
                                  style={{ color: signer.color }}
                                />
                              </div>
                            ),
                          )}
                        </div>

                        <RenderPdf
                          pageNumber={previewPageNumber}
                          pdfNewWidth={pdfNewWidth}
                          pdfDetails={templateData}
                          signerPos={generatePreviewData(signerPos)}
                          successEmail={false}
                          numPages={1}
                          pageDetails={pageDetails}
                          placeholder={true}
                          drop={drop}
                          handleDeleteSign={() => {}}
                          handleTabDrag={() => {}}
                          handleStop={() => {}}
                          setPdfLoad={() => {}}
                          pdfLoad={pdfLoad}
                          setSignerPos={() => {}}
                          containerWH={containerWH}
                          setIsResize={() => {}}
                          setZIndex={() => {}}
                          handleLinkUser={() => {}}
                          setUniqueId={() => {}}
                          signersdata={signersdata}
                          setIsPageCopy={() => {}}
                          setSignKey={() => {}}
                          isDragging={false}
                          setShowDropdown={() => {}}
                          setCurrWidgetsDetails={() => {}}
                          setWidgetType={() => {}}
                          setIsRadio={() => {}}
                          setSelectWidgetId={() => {}}
                          selectWidgetId=""
                          setIsCheckbox={() => {}}
                          setIsTextInput={() => {}}
                          handleNameModal={() => {}}
                          pdfOriginalWH={pdfOriginalWH}
                          setScale={() => {}}
                          scale={scale}
                          setIsSelectId={() => {}}
                          pdfBase64Url={pdfBase64Url}
                          fontSize={fontSize}
                          setFontSize={() => {}}
                          fontColor={fontColor}
                          setFontColor={() => {}}
                          isResize={false}
                          divRef={divRef}
                          setTempSignerId={() => {}}
                          uniqueId={""}
                          unSignedWidgetId={""}
                          handleWidgetClick={() => {}}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </PagePermissionGuard>
  );
};

export default ConfigureDocument;
